<div
  *ngIf="isOk != 'true' && isDelete != 'true' && isNormal != 'true'"
  class="button"
  [ngClass]="
    isLogin != 'true' && isAdd != 'true' && isCancel != 'true'
      ? 'button__normal'
      : isCancel == 'true'
      ? 'button__cancel'
      : ''
  "
>
  <div class="button-block">
    <svg
      [ngClass]="isAdd == 'true' ? 'button-block__plus-icon' : 'display-none'"
      viewBox="0 0 426.66667 426.66667"
    >
      <path
        d="m410.667969 229.332031h-394.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h394.667969c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
      />
      <path
        d="m213.332031 426.667969c-8.832031 0-16-7.167969-16-16v-394.667969c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v394.667969c0 8.832031-7.167969 16-16 16zm0 0"
      />
    </svg>
    <div
      [ngClass]="isCancel == 'false' ? 'button-block__title' : 'cancel-title'"
    >
      {{ title }}
    </div>
    <svg
      [ngClass]="
        isLogin == 'true' ? 'button-block__login-icon' : 'display-none'
      "
      viewBox="0 0 469 469.33333"
      class="button-block__login-icon"
    >
      <path
        d="m233.765625 0c-122.410156 0-222.804687 93.738281-233.597656 213.332031h190.933593v-64c0-8.617187 5.203126-16.402343 13.160157-19.710937 7.980469-3.304688 17.152343-1.472656 23.253906 4.628906l85.332031 85.335938c8.34375 8.339843 8.34375 21.820312 0 30.164062l-85.332031 85.332031c-6.101563 6.101563-15.273437 7.9375-23.253906 4.628907-7.957031-3.304688-13.160157-11.09375-13.160157-19.710938v-64h-190.933593c10.792969 119.59375 111.1875 213.332031 233.597656 213.332031 129.601563 0 234.667969-105.066406 234.667969-234.664062 0-129.601563-105.066406-234.667969-234.667969-234.667969zm0 0"
      />
    </svg>
  </div>
</div>
<div
  [ngClass]="
    isOk == 'true'
      ? 'ok-button'
      : isDelete == 'true'
      ? 'delete-button'
      : isNormal == 'true'
      ? 'normal-button'
      : 'display-none'
  "
>
  {{
    isOk == "true"
      ? "OK"
      : isDelete == "true"
      ? "Delete"
      : isNormal == "true"
      ? "Cancel"
      : ""
  }}
</div>
